<template>
   <main class="main-content flex-grow-1 p-4 overflow-auto mt-6" style="background-color: #f8f9fa;">
    <h2 class="text-header-page">Help</h2>
   <div class="row">
    <div class="col-md-8">
      <div class="card border-0 mb-4">
      <div class="card-body p-4">
        <h3 class="card-title mb-4">Frequently Asked Questions</h3>
        
        <!-- FAQ Skeleton Loader -->
        <div v-if="loading" class="faq-skeleton">
          <div class="skeleton-faq-item" v-for="i in 5" :key="i">
            <div class="d-flex align-items-center border-bottom py-3">
              <div class="flex-grow-1">
                <div class="skeleton-text skeleton-question"></div>
              </div>
              <div class="skeleton-icon"></div>
            </div>
          </div>
        </div>
        
        <!-- Actual FAQ Content -->
        <div v-else class="faq-list">
          <div class="faq-item" v-for="(item, index) in faqItems" :key="index">
            <div class="d-flex align-items-center border-bottom py-3" @click="toggleItem(index)" style="cursor: pointer;">
              <div class="flex-grow-1">
                <h6 class="mb-0 fw-bold">{{ item.question }}</h6>
              </div>
              <i class="fas" :class="item.isOpen ? 'fa-minus' : 'fa-plus'"></i>
            </div>
            <div class="py-3" v-if="item.isOpen" v-html="item.answer"></div>
          </div>
        </div>
      </div>
    </div>
    </div>
    <div class="col-md-4">
      <!-- Speak with Expert Skeleton Loader -->
      <div v-if="loading" class="skeleton-expert-card">
        <div class="skeleton-expert-content">
          <div class="skeleton-expert-icon"></div>
          <div class="skeleton-expert-text">
            <div class="skeleton-text skeleton-expert-title"></div>
            <div class="skeleton-text skeleton-expert-subtitle"></div>
          </div>
          <div class="skeleton-expert-button"></div>
        </div>
      </div>
      
      <!-- Actual Speak with Expert Content -->
      <div v-else class="card border-0 shadow-sm bg-dark text-white expert-card" 
           :style="{ backgroundImage: 'url(/assets/bg-help.png)' }">
          <div class="card-body p-4">
            <div class="me-3">
              <img src="/assets/call.png" alt="Phone Icon" class="expert-icon" 
                @error="handleImageError">
            </div>
            <div class="flex-grow-1">
              <h3 class="card-title mb-1 text-white">Speak with Expert</h3>
              <p class="mb-0 small opacity-75">Our team is ready to help you simplify and scale your payment processes.
              </p>
            </div>
            <div>
              <a href="https://wa.me/6281111839982" target="_blank" class="btn btn-success px-4">
                <i class="fab fa-whatsapp me-2"></i>Contact Us
              </a>
            </div>
          </div>
        </div>
    </div>
   </div>
  </main>
</template>

<script>
import { getFaq } from '../../api/app';

export default {
  data() {
    return {
      faqItems: [],
      loading: false,
    };
  },
  methods: {
    toggleItem(index) {
      this.faqItems[index].isOpen = !this.faqItems[index].isOpen;
    },
    async fetchFaq(){
      this.loading = true;
      try {
        const response = await getFaq();
        if (response.status == 'success'){
          this.faqItems = response.data.map(item => ({
            question: item.question,
            answer: item.answer,
            isOpen: false
          }));
        }
      } catch (error) {
        console.error('Error fetching FAQ:', error);
      } finally {
        this.loading = false;
      }
    },
    handleImageError(event) {
      event.target.src = "/assets/call.png"; // Fallback to default image
    }
  },
  mounted() {
    this.fetchFaq();
  }
};
</script>

<style scoped>
/* FAQ Skeleton Loader Styles */
.faq-skeleton {
  margin-top: 1rem;
}

.skeleton-faq-item {
  margin-bottom: 0.5rem;
}

.skeleton-text {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 6px;
}

.skeleton-question {
  width: 75%;
  height: 20px;
}

.skeleton-icon {
  width: 16px;
  height: 16px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 50%;
}

/* Expert Card Skeleton Styles */
.skeleton-expert-card {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 0.5rem;
  padding: 1.5rem;
  min-height: 180px;
}

.skeleton-expert-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.skeleton-expert-icon {
  width: 48px;
  height: 48px;
  background-color: #c0c0c0;
  border-radius: 50%;
  margin-bottom: 1rem;
}

.skeleton-expert-text {
  margin-bottom: 1rem;
}

.skeleton-expert-title {
  width: 60%;
  height: 24px;
  margin-bottom: 0.5rem;
  background-color: #c0c0c0;
}

.skeleton-expert-subtitle {
  width: 90%;
  height: 16px;
  background-color: #c0c0c0;
}

.skeleton-expert-button {
  width: 100px;
  height: 40px;
  background-color: #c0c0c0;
  border-radius: 0.375rem;
}

/* Expert Card Styles */
.expert-card {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.expert-icon {
  width: 48px;
  height: 48px;
  object-fit: contain;
}

/* Animations */
@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
}

/* FAQ Hover Effects */
.faq-item:hover {
  background-color: #f8f9fa;
  border-radius: 8px;
  transition: background-color 0.2s ease;
}

/* Responsive Design */
@media (max-width: 768px) {
  .skeleton-expert-card {
    margin-top: 1rem;
  }
  
  .skeleton-question {
    width: 85%;
  }
}
</style>